<template>
    <div class="absolute">
        <!-- <h2>Indicador 11 mapa</h2> -->
        <div ref="wrapper" class="mx-auto w-[95vw] h-[85vh]">
            <!-- <svg viewBox="0 0 600 300"> -->
            <svg :width="size.width" :height="size.height" id="svg_chart">
                <g>
                    <path :fill="filteredColor(d)" :stroke="colors.light_green" stroke-width="2" v-for="d in this.geodata" :key="d.properties.COD_AED" :d="geoGenerator(d.geometry)"></path>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'
const fullConfig = resolveConfig(tailwindConfig)

export default {
    // 1. Access and parse data (data(), as a prop)
    // 2. Create chart dimensions (computed, because of resizing)?
    // 3. Render chart (template)
    // 4. Create scales (computed, bcause of data change)
    // 5. Render data (computed, bcause of data change)
    // 6. Render peripherals (computed, because of data change or resizing)
    // 7. Create and add interactions (template and computed)
    data() {
        return {
            publicPath: process.env.BASE_URL,
            dataset: null,
            geodata: null,
            mapdata: null,
            hovered: null,
            projection: null,
            chartLoaded: false,
            cityArray: [],
            // filteredColor: 'green',

            size: {
                width: 1200,
                height: 500,
                pad: 0.5,
                margin: {
                    left: 180,
                    right: 60,
                    top: 10,
                    bottom: 30,
                },
            },
            colors: {
                light_green: fullConfig.theme.colors['light-green'],
                moss: fullConfig.theme.colors['moss'],
            },

            tooltipPos: {
                x: 0,
                y: 0,
            },
        }
    },

    async mounted() {
        const dataset = await d3.csv(this.publicPath + 'static/resumo-executivo/data/11_Geografia-PIPE.csv')
        const geodata = await d3.json(this.publicPath + 'static/resumo-executivo/geo/geojs-35-mun.json')
        this.dataset = dataset
        this.mapdata = geodata
        this.geodata = geodata.features
        this.dataLoaded = true
        this.init()
    },
    methods: {
        // Initialize functions
        init: function () {
            for (let i = 0; i < this.dataset.length - 1; i++) {
                let d = this.dataset[i]
                this.cityArray.push(this.cityAccessor(d))
            }
            this.setSizes()
            this.projection = d3.geoMercator().fitSize([this.size.width, this.size.height], this.mapdata)
        },

        // Sizes
        setSizes: function () {
            this.size.height = this.$refs.wrapper.clientHeight
            this.size.width = this.$refs.wrapper.clientWidth

            let padBetweenNo = this.dataset.length - 1
            let padBetweenWidth = (this.bounds.width / 100) * this.size.pad
            let padBetweenTotal = padBetweenNo * padBetweenWidth
            let rectWidth = (this.bounds.width - padBetweenTotal) / this.dataset.length

            this.size.rectWidth = rectWidth
            this.size.padBetweenWidth = padBetweenWidth
        },

        // Map
        geoGenerator: function (d) {
            // let projection =
            // console.log('draw')
            const path = d3.geoPath().projection(this.projection)
            return path(d)
        },

        // Accessors
        featureAccessor: function (d) {
            let val = d.properties.name
            return val
        },

        cityAccessor: function (d) {
            let val = d['Cidade']
            return val
        },

        filteredColor: function (d) {
            let val
            // let cityName = this.cityAccessor(d)
            let checkCity = this.cityArray.includes(this.featureAccessor(d))
            // console.log(checkCity)
            if (checkCity) {
                val = this.colors.moss
            } else {
                val = this.colors.light_green
            }
            return val
        },

        // yAccessor: function (d) {
        //     let val = parseInt(d['Projetos'])
        //     return val
        // },

        // // Scales
        // xScale: function (d) {
        //     const xScale = d3.scaleLinear().domain(d3.extent(this.dataset, this.xAccessor)).range([0, this.bounds.width])

        //     return d ? xScale(d) : xScale
        // },

        // yScale: function (d) {
        //     const yScale = d3.scaleLinear().domain(d3.extent(this.dataset, this.yAccessor)).range([this.bounds.height, 0])

        //     return d ? yScale(d) : yScale
        // },

        // // Axis
        // axisGenerator() {
        //     const xAxisGenerator = d3.axisBottom().scale(this.xScale())
        //     const xAxis = d3.select(this.$refs.xAxis).call(xAxisGenerator)
        //     xAxis.attr('class', 'graph_axis graph_x_axis')

        //     const yAxisGenerator = d3.axisLeft().scale(this.yScale())
        //     const yAxis = d3.select(this.$refs.yAxis).call(yAxisGenerator)
        //     yAxis.attr('class', 'graph_axis graph_y_axis')
        // },

        // Animation
    },
    watch: {
        // chartLoaded: function () {
        //     console.log('chart loaded')
        //     // this.animateChart()
        // },
    },

    computed: {
        // Calculate bounds based on window size
        bounds: function () {
            return {
                width: this.size.width - this.size.margin.left - this.size.margin.right,
                height: this.size.height - this.size.margin.top - this.size.margin.bottom,
            }
        },

        // Generate Map
        // mapGenerator: function () {},
    },
}
</script>
